<template>
  <div class="task-detail-container">
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-back" @click="goBack">返回</el-button>
        <h2>短信任务详情</h2>
      </div>
      <div class="header-right">
        <el-button 
          v-if="taskDetail.taskStatus === 'pending'"
          type="danger" 
          @click="cancelTask"
        >取消任务</el-button>
        <el-button type="primary" @click="refreshData">刷新</el-button>
      </div>
    </div>

    <el-card class="task-info">
      <div slot="header">
        <span>任务信息</span>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="任务状态">
          <el-tag :type="getTaskStatusType(taskDetail.taskStatus)">
            {{ getTaskStatusText(taskDetail.taskStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ formatDateTime(taskDetail.createdAt) }}
        </el-descriptions-item>
        <el-descriptions-item label="开始时间">
          {{ formatDateTime(taskDetail.startedAt) }}
        </el-descriptions-item>
        <el-descriptions-item label="完成时间">
          {{ formatDateTime(taskDetail.completedAt) }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="task-config">
      <div slot="header">
        <span>配置信息</span>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="会议标题">
          {{ taskDetail.config?.conferenceTitle }}
        </el-descriptions-item>
        <el-descriptions-item label="会议时间">
          {{ taskDetail.config?.dateRangeText }}
        </el-descriptions-item>
        <el-descriptions-item label="会议城市">
          {{ taskDetail.config?.city }}
        </el-descriptions-item>
        <el-descriptions-item label="详细地址">
          {{ taskDetail.config?.addressDetails }}
        </el-descriptions-item>
        <el-descriptions-item label="任务负责人">
          {{ taskDetail.config?.taskContact }}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          {{ taskDetail.config?.taskContactPhone }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="task-progress">
      <div slot="header">
        <span>发送进度</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-title">总计</div>
            <div class="stat-value">{{ taskDetail.statistics?.total || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-title">待发送</div>
            <div class="stat-value">{{ taskDetail.statistics?.pending || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-title">已发送</div>
            <div class="stat-value">{{ taskDetail.statistics?.sent || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-title">失败</div>
            <div class="stat-value">{{ taskDetail.statistics?.failed || 0 }}</div>
          </div>
        </el-col>
      </el-row>
      <el-progress 
        :percentage="getProgressPercentage(taskDetail.statistics)"
        :status="getProgressStatus(taskDetail.taskStatus)"
      ></el-progress>
    </el-card>

    <el-card class="guest-list">
      <div slot="header">
        <span>发送列表</span>
      </div>
      <el-table
        :data="taskDetail.targetGuests"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="嘉宾姓名" width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
        <el-table-column prop="position" label="职位" width="120"></el-table-column>
        <el-table-column label="发送状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getGuestStatusType(scope.row.status)">
              {{ getGuestStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sentAt" label="发送时间" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.sentAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="errorMessage" label="失败原因"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'SmsTaskDetail',
  
  data() {
    return {
      taskId: '',
      archiveId: '',
      taskDetail: {},
      pollingTimer: null
    };
  },
  
  created() {
    // 从路由参数中获取 taskId 和 archiveId
    const { taskId, archiveId } = this.$route.params;
    
    // 如果 params 中没有，则尝试从 query 中获取
    this.taskId = taskId || this.$route.query.taskId;
    this.archiveId = archiveId || this.$route.query.archiveId;
    
    console.log('Route params:', this.$route.params);
    console.log('Route query:', this.$route.query);
    console.log('TaskId:', this.taskId);
    console.log('ArchiveId:', this.archiveId);
    
    if (!this.taskId || !this.archiveId) {
      this.$message.error('缺少必要参数');
      this.goBack();
      return;
    }
    
    this.loadTaskDetail();
  },
  
  beforeDestroy() {
    this.stopPolling();
  },
  
  methods: {
    async loadTaskDetail() {
      try {
        const response = await request.get('/sms/tasks', {
          params: {
            archiveId: this.archiveId
          }
        });
        console.log('当前任务ID:', this.taskId);
        console.log('API Response:', response);
        
        if (response?.status === '10000') {
          const tasks = response?.data?.tasks;
          if (Array.isArray(tasks) && tasks.length > 0) {
            const task = tasks.find(task => task.taskId === this.taskId);
            if (task) {
              this.taskDetail = task;
              this.checkAndStartPolling();
            } else {
              console.error('未找到任务，当前任务ID:', this.taskId);
              console.error('可用的任务列表:', tasks.map(t => ({ taskId: t.taskId, _id: t._id })));
              this.$message.error('未找到对应的任务详情');
            }
          } else {
            console.error('任务列表为空或格式不正确');
            this.$message.error('任务列表为空或格式不正确');
          }
        } else {
          this.$message.error(response?.message || '获取任务详情失败');
        }
      } catch (error) {
        console.error('获取任务详情失败:', error);
        this.$message.error(error?.message || '获取任务详情失败');
      }
    },
    
    checkAndStartPolling() {
      const isActive = this.taskDetail.taskStatus === 'pending' || 
                      this.taskDetail.taskStatus === 'processing';
      
      if (isActive && !this.pollingTimer) {
        this.startPolling();
      } else if (!isActive && this.pollingTimer) {
        this.stopPolling();
      }
    },
    
    startPolling() {
      if (this.pollingTimer) return;
      
      this.pollingTimer = setInterval(() => {
        this.loadTaskDetail();
      }, 5000); // 5秒轮询一次
    },
    
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    
    async cancelTask() {
      try {
        await this.$confirm('确定要取消这个发送任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await this.$http.post('/sms/task/cancel', {
          taskId: this.taskId
        });
        
        if (response.data.status === '10000') {
          this.$message.success('任务已取消');
          this.loadTaskDetail();
        } else {
          this.$message.error(response.data.message || '取消任务失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消任务失败:', error);
          this.$message.error('取消任务失败');
        }
      }
    },
    
    refreshData() {
      this.loadTaskDetail();
    },
    
    goBack() {
      this.$router.push({
        path: '/mall/schedule',
        query: { archiveId: this.archiveId }
      });
    },
    
    getTaskStatusType(status) {
      const statusMap = {
        pending: 'info',
        processing: 'warning',
        completed: 'success',
        cancelled: 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    getTaskStatusText(status) {
      const statusMap = {
        pending: '待处理',
        processing: '处理中',
        completed: '已完成',
        cancelled: '已取消'
      };
      return statusMap[status] || '未知';
    },
    
    getGuestStatusType(status) {
      const statusMap = {
        pending: 'info',
        sending: 'warning',
        sent: 'success',
        failed: 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    getGuestStatusText(status) {
      const statusMap = {
        pending: '待发送',
        sending: '发送中',
        sent: '已发送',
        failed: '发送失败'
      };
      return statusMap[status] || '未知';
    },
    
    getProgressPercentage(statistics) {
      if (!statistics || statistics.total === 0) return 0;
      const completed = statistics.sent + statistics.failed;
      return Math.round((completed / statistics.total) * 100);
    },
    
    getProgressStatus(taskStatus) {
      if (taskStatus === 'completed') return 'success';
      if (taskStatus === 'cancelled') return 'exception';
      return null;
    },
    
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.task-detail-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
  
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .header-left {
      display: flex;
      align-items: center;
      
      h2 {
        margin: 0 0 0 15px;
      }
    }
  }
  
  .el-card {
    margin-bottom: 20px;
  }
  
  .task-progress {
    .el-progress {
      margin-top: 20px;
    }
  }
  
  .stat-card {
    text-align: center;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
    
    .stat-title {
      font-size: 14px;
      color: #909399;
      margin-bottom: 10px;
    }
    
    .stat-value {
      font-size: 24px;
      font-weight: bold;
      color: #303133;
    }
  }
}
</style> 